module.exports = __webpack_public_path__ + "img/p-14-2.ff646ade.jpg";